import React, { useEffect, useState } from 'react'
import Listing from '../../components/Airbnb/Listing'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getAirbnbBackdrop, getAirbnbListings, getAirbnbStatus } from '../../reducers/airbnb/selectors'
import styled, { ITheme } from '../../theme'
import { isLicenseValid } from '../../reducers/userAccount/selectors/license'
import NoPremium from './NoPremium'
import { IntegrationAction } from '../../reducers/airbnb/actionNames'
import DisconnectModal from './Modals/DisconnectModal'
import ConnectModal from './Modals/ConnectModal'
import { createListing, deleteListing, getAirbnbRoomConfiguration } from '../../actions/airbnb'
import { is } from '../../components/MediaQuery'
import IntegrationModal from '../../screens/PriceGrid2/Components/integrationModal/integrationModal'
import { getIsMultiPriceEnabled } from '../../reducers/userObject/selectors/settings'
import { getPriceConfig } from '../../reducers/price/selectors/price'
import { IntegrationStatus } from '../../reducers/airbnb'
import { clone } from 'lodash'
import { PriceConfigurationActions } from '../../reducers/price/actionNames'

const ListingWrapper = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 20px;
  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
    padding-left: 0px;
    width: 100%;
  }
`

const Text = styled.div`
  width: 898px;
  padding-top: 45px;
  background-size: cover;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  color: #696a6d;
  text-decoration: none solid rgb(105, 106, 109);
  text-align: center;

  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
    width: unset;
    padding-top: 20px;
    background-size: cover;
    font-family: Montserrat, sans-serif;
    font-size: 12px;
    color: #696a6d;
    text-decoration: none solid rgb(105, 106, 109);
    text-align: justify;
  }
`

function ConnectListings({ mobile, unblock }: IConnectListings) {
  const { t } = useTranslation()
  const listings = useSelector(getAirbnbListings)
  const [openDisconnect, setOpenDisconnect] = useState(false)
  const [openConnect, setOpenConnect] = useState(false)
  const backdrop = useSelector(getAirbnbBackdrop)
  const [loading, setLoading] = useState(false)
  const isDesktop = is.desktop()
  const isPremium = useSelector(isLicenseValid)
  const [integrationOpen, setIntegrationOpen] = useState<any>(false)
  const multiPrices = useSelector(getIsMultiPriceEnabled)
  const config = useSelector(getPriceConfig)
  const status = useSelector(getAirbnbStatus)

  const handleIntegrationClose = () => {
    setIntegrationOpen(false)
  }

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch({ type: IntegrationAction.SetAirbnbBackdrop, payload: false })
    setOpenConnect(false)
    setOpenDisconnect(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!isPremium) {
      dispatch({ type: IntegrationAction.SetAirbnbBackdrop, payload: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPremium])

  const handleDisconnetModalClose = () => {
    setOpenDisconnect(false)
    dispatch({ type: IntegrationAction.SetAirbnbBackdrop, payload: false })
  }

  const connect = room => () => {
    setOpenConnect(false)
    const listing = clone(openConnect)
    dispatch({ type: IntegrationAction.SetAirbnbBackdrop, payload: false })
    connectRoom(room, listing)()
  }
  const handleConnectModalClose = () => {
    setOpenConnect(false)
    dispatch({ type: IntegrationAction.SetAirbnbBackdrop, payload: false })
  }

  const disconnectListing = () => {
    dispatch(
      deleteListing({
        id_room: openDisconnect && (openDisconnect as any).bedbooking_id_room,
        id_listing: openDisconnect && (openDisconnect as any).id,
      }),
    )
    setOpenDisconnect(false)
    dispatch({ type: IntegrationAction.SetAirbnbBackdrop, payload: false })
  }

  const connectRoom = (room, listing) => () => {
    if (multiPrices && status === IntegrationStatus.Integrated && Boolean(Number(config.integrations.airbnb.active))) {
      setIntegrationOpen(room+(listing? '-'+listing.id:''))
    } else {
      setLoading(true)
      dispatch(
        createListing({
          id_room: Number(room),
          id_listing: listing?listing.id: openConnect && (openConnect as any).id,
        }),
      )
      setTimeout(() => {
        setLoading(false)
        dispatch(getAirbnbRoomConfiguration(Number(room)))
        if (unblock) {
          unblock()
        }
        // history.push(
        //   mobile ? '/integration/room?mobile=1' : '/integration/room',
        //   {},
        // )
      }, 5000)
    }
  }

  const handleConnect = (value) => {
    setLoading(true)
    const o = clone(integrationOpen)
    const room = o.split('-')[0]
    const listing = o.split('-')[1]
    dispatch(
      createListing({
        id_room: Number(room),
        id_listing: listing? listing:openConnect && (openConnect as any).id,
        price_import: Number(value),
      }),
    )

    if(Boolean(Number(value))) {
    dispatch({type: PriceConfigurationActions.PriceConfigurationAccepted, configuration: {
        ...config,
        integrations: {
          ...config.integrations,
          airbnb: {
            ...config.integrations.airbnb,
            active: '0',
          }
        }}})
      }

    setTimeout(() => {
      setLoading(false)
      dispatch(getAirbnbRoomConfiguration(Number(room)))
      if (unblock) {
        unblock()
      }
      // history.push(
      //   mobile ? '/integration/room?mobile=1' : '/integration/room',
      //   {},
      // )
    }, 2000)
    handleIntegrationClose()
  }

  return (
    <>
      <IntegrationModal open={integrationOpen} type={'Airbnb'} handleClose={handleIntegrationClose} handleConnect={handleConnect}/>
      <NoPremium open={!isPremium} />
      <DisconnectModal
        listing={openDisconnect}
        open={openDisconnect}
        handleClose={handleDisconnetModalClose}
        action={disconnectListing}
      />
      <ConnectModal
        listing={openConnect}
        connect={connect}
        open={openConnect}
        handleClose={handleConnectModalClose}
        loading={loading}
      />
      <div
        style={{
          marginTop: '20px',
          opacity: backdrop ? 0.2 : 1,
          pointerEvents: backdrop ? 'none' : 'unset',
          paddingRight: isDesktop ? '30px' : '0px',
        }}
      >
        {listings.length === 0 ? (
          <Text style={{ padding: '20px' }}>{t('OUT_23_no_room')}</Text>
        ) : (
          <>
            {listings.filter(l => !l.bedbooking_id_room).length !== 0 && (
              <ListingSection label={t('BED_6451_rooms_to_connect')}>
                {listings
                  .filter(l => !l.bedbooking_id_room)
                  .map((listing, index) => (
                    <>
                      <ListingWrapper>
                        <Listing
                          setOpenDisconnect={setOpenDisconnect}
                          unblock={unblock}
                          setOpenConnect={setOpenConnect}
                          mobile={mobile}
                          listing={listing}
                          disableBorder={listings.length === index + 1}
                        />
                      </ListingWrapper>
                    </>
                  ))}
              </ListingSection>
            )}
            {listings.filter(l => !!l.bedbooking_id_room).length !== 0 && (
              <ListingSection label={t('BED_6451_connected_rooms')}>
                {listings
                  .filter(l => !!l.bedbooking_id_room)
                  .map((listing, index) => (
                    <>
                      <ListingWrapper>
                        <Listing
                          setOpenDisconnect={setOpenDisconnect}
                          unblock={unblock}
                          setOpenConnect={setOpenConnect}
                          mobile={mobile}
                          listing={listing}
                          disableBorder={listings.length === index + 1}
                        />
                      </ListingWrapper>
                    </>
                  ))}
              </ListingSection>
            )}
          </>
        )}
      </div>
    </>
  )
}

const ListingSection = ({ children, label }) => {
  return (
    <div>
      <ListingSectionLabel>{label}</ListingSectionLabel>
      <div>{children}</div>
    </div>
  )
}

const ListingSectionLabel = styled.div`
  margin: 30px 0px;
  border-radius: 4px;
  background-size: cover;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  color: #121212;
  font-weight: bold;
  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
    padding: 0px 15px;
  }
`

export interface IConnectListings {
  mobile: any
  unblock: any
}

export default ConnectListings
